angular.module('bmsApp.employee').controller('EmployeeIndexCtrl', function ($scope,
																			$state,
																			$cookies,
																			EmployeeSvc,
																			ngTableParams,
																			$localStorage) {

	$scope.loading = true;
	$scope.updating = false;
	//$scope.employeeTotalCount = 0;
	$scope.employeeResultCount = 0;

	var defaultEmployeeParams = function () {
		return {
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				display_name: 'asc'     // initial sorting
			},
			filter: {
				status: true,
				search: ''
			}
		};
	};

	var initialEmployeeParams = function () {
		if (angular.isDefined($localStorage.employeeIndexParams)) {
			return angular.extend({}, defaultEmployeeParams(), $localStorage.employeeIndexParams);
		}
		else {
			return angular.extend({}, defaultEmployeeParams());
		}
	};

	var params = initialEmployeeParams();

	// copy the filters to a workable state
	$scope.employeeFilters = angular.copy(params.filter);

	$scope.tableParams = new ngTableParams(params, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$localStorage.employeeIndexParams = params.$params;
			$scope.updating = true;
			EmployeeSvc.index(params.$params)
				.then(function (response) {
					params.total(response.data.employee_filtered_count);
					$defer.resolve(response.data.employee_collection);
					$scope.employeeTotalCount = $scope.employeeIndex.totalCount = response.data.employee_total_count;
					$scope.employeeResultCount = $scope.employeeIndex.resultCount = response.data.employee_filtered_count;
					$scope.$emit('employeeIndexUpdated', {
						employee_collection: response.data.employee_collection,
						employee_total_count: response.data.employee_total_count,
						employee_filtered_count: response.data.employee_filtered_count
					});
					// Check if we've exceeded our page size, if we have, go back
					if (response.data.employee_filtered_count > 0 && !response.data.employee_collection.length) {
						let newParams = angular.copy($scope.tableParams.$params);
						newParams.page--;
						angular.extend($scope.tableParams.$params, newParams);
					}

					$scope.updating = false;
					$scope.loading = false;
				});
		}
	});

	// Store the table params whenever anything changes
	$scope.$watch('tableParams.$params', function (value) {
		if (angular.isObject(value)) {
			$cookies.employeeIndexParams = JSON.stringify(value);
		}
	}, true);

	// update text search without having to click apply
	$scope.filterChanged = function () {
		$scope.tableParams.$params.filter.search = $scope.employeeFilters.search;
	};

	// other filters
	$scope.filterApply = function () {
		angular.extend($scope.tableParams.$params.filter, angular.copy($scope.employeeFilters));
	};

	$scope.filterReset = function () {
		angular.extend($scope.tableParams.$params, defaultEmployeeParams());
		angular.extend($scope.employeeFilters, defaultEmployeeParams().filter);
	};

	EmployeeSvc.statistics()
		.then(function (response) {
			$scope.statistics.total = response.data.statistics.total;
			$scope.statistics.active = response.data.statistics.active;
			$scope.statistics.inactive = response.data.statistics.inactive;
			$scope.statistics.retention_rate = response.data.statistics.retention_rate;
		});

	$scope.rowClicked = function (employee) {
		$state.go('main.employee.index.view', {
			employeeId: employee.id
		});
	};


	$scope.$on('employeeIndexExport', function () {
		var params = angular.copy($scope.tableParams.$params);
		console.log(params);

		EmployeeSvc.export(params);
	});

});
